import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@domain-group/suit-theme'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

const ProfileSettings = (props) => {
  const { publicationForm } = props

  const {
    entityState: {
      options,
    },
  } = publicationForm

  const {
    domain_coco = 'false',
    downsample_color_images = false,
    optimize_files = false,
    notes = false,
    page_position = 'false',
    product_options = 'false',
    strip_image_profile = 'false',
  } = options || {}

  return (
    <Box flexDirection="column">
      <ToggleListItem
        onClick={() => (
          toggleNestedValue(publicationForm, 'options.domain_coco', { isString: true, shouldSetState: true })
        )}
        toggleValue={domain_coco === 'true'}
      >
        <ToggleListItem.Title>Domain Coast &amp; Country</ToggleListItem.Title>
        <ToggleListItem.Description>Pages are in the Coast &amp; Country</ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => (
          toggleNestedValue(publicationForm, 'options.strip_image_profile', { isString: true, shouldSetState: true })
        )}
        toggleValue={strip_image_profile === 'true'}
      >
        <ToggleListItem.Title>Strip Image Profiles</ToggleListItem.Title>
        <ToggleListItem.Description>Remove any image profiles before delivery</ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => toggleNestedValue(publicationForm, 'options.optimize_files', { shouldSetState: true })}
        toggleValue={optimize_files}
      >
        <ToggleListItem.Title>Optimize Files</ToggleListItem.Title>
        <ToggleListItem.Description>Reduce file size before delivery</ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => toggleNestedValue(publicationForm, 'options.downsample_color_images', { shouldSetState: true })}
        toggleValue={downsample_color_images}
      >
        <ToggleListItem.Title>Downsample Images</ToggleListItem.Title>
        <ToggleListItem.Description>Reduce or downsample images prior to delivery of pages</ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => (
          toggleNestedValue(publicationForm, 'options.page_position', { isString: true, shouldSetState: true })
        )}
        toggleValue={page_position === 'true'}
      >
        <ToggleListItem.Title>Enable Page Position</ToggleListItem.Title>
        <ToggleListItem.Description>
          Allow the delivery to determine page position (Left and Right)
        </ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => toggleNestedValue(publicationForm, 'options.notes', { shouldSetState: true })}
        toggleValue={notes}
      >
        <ToggleListItem.Title>Enable Notes</ToggleListItem.Title>
        <ToggleListItem.Description>Include notes with file delivery</ToggleListItem.Description>
      </ToggleListItem>

      <ToggleListItem
        onClick={() => (
          toggleNestedValue(publicationForm, 'options.product_options', { isString: true, shouldSetState: true })
        )}
        toggleValue={product_options === 'true'}
      >
        <ToggleListItem.Title>Enable Product Options</ToggleListItem.Title>
        <ToggleListItem.Description>Include product options with file delivery</ToggleListItem.Description>
      </ToggleListItem>
    </Box>
  )
}

ProfileSettings.propTypes = {
  publicationForm: PropTypes.shape({
    entityState: PropTypes.object.isRequired,
    handlers: PropTypes.object.isRequired,
    setEntityState: PropTypes.func.isRequired,
  }).isRequired,
}

export default ProfileSettings
